import { CASES } from './constants';

const getInitialTitleSort = () => {
    const saved = localStorage.getItem('titleSort');
    return saved ? JSON.parse(saved) : ['id', 'DESC'];
};


const initialState = {
    titles: [],
    filterForm: {
        foxFinancialTitleId: '',
        title: '',
        productType: '',
        legalStatusId: '',
        keywords: '',
        clearanceMemoMapped: '',
        clearanceMemoImported: '',
        foxipediaId: '',
        lifeCycleStatus: '',
    },
    legalStatusOptions: [
        { label: 'CONFIRMED', value: 1 },
        { label: 'DRAFT', value: 2 },
        { label: 'PENDING', value: 3 },
        { label: 'PENDING WITH FEATURE CAVEAT', value: 4 },
        { label: 'PRELIMINARY', value: 5 },
        { label: 'PROCESSING', value: 7 },
    ],
    importedAndMappedOptions: [
        { label: 'YES', value: 'true' },
        { label: 'NO', value: 'false' },
    ],
    totalPages: 0,
    totalItems: 0,
    currentPage: 0,
    filterParam: '',
    titleRange: [0, 19],
    titleSort: getInitialTitleSort(),
    defaultFilterRange: [0, 19],
    itemsPerPage: 20,
    isMemoModalOpen: false,
    isSectionModalOpen: false,
    isViewOnly: false,
    title: {},
    section: {},
    product: {},
    clearanceMemoTOC: [],
};

/**
 * Reducer function to manage the clearance memo titles state in the Redux store.
 *
 * It handles actions related to updating clearance memo titles,
 * filtering clearance memo titles, and clearing clearance memo titles.
 *
 * @param {Object} state - The current state of the clearance memo titles.
 * @param {Object} action - The action dispatched to the reducer.
 * @return {Object} The new state of the clearance memo titles after applying the action.
 **/
export function titles(state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case CASES.UPDATE_CLEARANCE_MEMO_TITLES: {
            if (payload.titleSort) {
                localStorage.setItem('titleSort', JSON.stringify(payload.titleSort));
            }
            return { ...state, ...payload };
        }
        case CASES.UPDATE_CLEARANCE_MEMO_TITLES_FILTER_FORM: {
            const { data, key } = payload;
            return { ...state, [key]: { ...state[key], ...data } };
        }
        case CASES.CLEAR_CLEARANCE_MEMO_TITLES: {
            return {
                ...initialState,
                titlesSort: state.titlesSort
            };
        }
        default:
            return state;
    }
}
